module.exports = __webpack_public_path__ + "img/19.1de2a270.jpg";